import { render, staticRenderFns } from "./emergencyForm.vue?vue&type=template&id=57a1c94e"
import script from "./emergencyForm.vue?vue&type=script&lang=js"
export * from "./emergencyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports